import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, message, Space, Button } from 'antd';
import { apiRequest } from '../../../../service/apiRequest';
import { showSuccess, showError } from '../../../../components/errorHandler';

interface OccupationModalProps {
  visible: boolean;
  onCancel: () => void;
  onCreate: (data: any) => void; // callback after successful create/update
  isEditMode: boolean;
  initialValues: { occupation_id: number; occupation_name: string; occupation_status: number } | null;
}

const OccupationModel: React.FC<OccupationModalProps> = ({
  visible,
  onCancel,
  onCreate,
  isEditMode,
  initialValues,
}) => {
  const [form] = Form.useForm();
  const isSubmitDisabled = () => {
    const errors = form.getFieldsError();
    return errors.some(({ errors }) => errors.length > 0);
  };
  const [isModalClose, setIsModalClose] = useState(true);
  useEffect(() => {
    if (isEditMode && initialValues) {
      form.setFieldsValue({
        occupation_name: initialValues.occupation_name,
      });
    } else {
      form.resetFields();
    }
  }, [isEditMode, initialValues, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const dataVal = {
        occupation_name: values.occupation_name,
        ...(initialValues?.occupation_id && { pi_id: initialValues.occupation_id }),
      };
      const url = isEditMode ? 'edit-occupation' : 'add-occupation';

      const method = isEditMode ? 'put' : 'post';

      // Update existing occupation
      const data = await apiRequest({
        method: method,
        url: url,
        data: dataVal,
      });

      showSuccess(
        isEditMode ? 'Occupation updated successfully' : 'Occupation created successfully!',
      );
      form.resetFields();

      onCreate(data); // refresh table data
      if (isModalClose) {
        onCancel(); // Close modal if Submit button clicked
      }
    } catch (error: any) {
      if (error.errorFields) {
        // validation error, do nothing
      } else {
        showError('Failed to save occupation');
        console.error(error);
      }
    }
  };

  return (
    <Modal
      open={visible}
      title={isEditMode ? 'Edit Occupation' : 'Add Occupation'}
      onCancel={onCancel}
      destroyOnHidden
      footer={null}  
    >
      <Form form={form}
    layout="vertical"
    name="occupation_form"
    onFinish={handleSubmit}>
        <Form.Item
          label="Occupation Name"
          name="occupation_name"
          rules={[{ required: true, message: 'Please enter occupation name' }]}
        >
          <Input showCount maxLength={255} placeholder="Enter occupation name" />
        </Form.Item>
        <Form.Item style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Space>
            <Button onClick={onCancel}>Cancel</Button>
            {!isEditMode && (
              <Button
                type="primary"
                htmlType="submit"
                onClick={() => setIsModalClose(false)}
                disabled={isSubmitDisabled()}
              >
                Submit & Create New Occupation
              </Button>
            )}
            <Button
              type="primary"
              htmlType="submit"
              onClick={() => setIsModalClose(true)}
              disabled={isSubmitDisabled()}
            >
              Submit
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default OccupationModel;
